import { useAuth } from '@clerk/clerk-react';
import { useCallback } from 'react';

export const useApi = () => {
  const { userId } = useAuth();

  const apiFetch = useCallback(
    async (api: string, options: RequestInit = {}) => {
      const headers: HeadersInit = {
        'Content-Type': 'application/json',
        ...options.headers,
      };

      if (userId) {
        (headers as Record<string, string>)['x-user-id'] = userId;
      }

      return fetch(`${process.env.REACT_APP_SERVER_URL}/api/${api}`, {
        ...options,
        headers,
      });
    },
    [userId]
  );

  return { apiFetch };
};

export default useApi;
